export const shapes = ['Rectangle', 'RoundedRectangle', 'Ellipse', 'Triangle'];
export const colors = ['lightcoral', 'lightblue', 'lightgreen', 'lightyellow', 'lightgray'];
